import { Card } from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';

export function ForecastPaginatedProductDetailsSkeleton() {
  return (
    <Card className='mr-0 flex h-44 w-full flex-col gap-y-4 p-4 lg:mr-4 lg:w-2/3'>
      <div className='flex flex-row items-center'>
        <Skeleton className='h-7 w-full' />
      </div>
      <div className='flex flex-col gap-y-4 text-xs'>
        <div className='flex flex-row justify-between gap-x-4'>
          <Skeleton className='h-4 w-60' />
          <Skeleton className='h-4 w-60' />
        </div>
        <div className='flex flex-row justify-between gap-x-4'>
          <Skeleton className='h-4 w-60' />
          <Skeleton className='h-4 w-60' />
        </div>
        <div className='flex flex-row justify-between gap-x-4'>
          <Skeleton className='h-4 w-60' />
          <Skeleton className='h-4 w-72' />
        </div>
      </div>
    </Card>
  );
}
